import { Link } from 'react-router-dom';

export function AGB() {
  return (
    <div className="mt-[70px]">
      <section className="relative pt-16 pb-10 text-center border-b border-white/[0.06] overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full bg-gold/[0.04] blur-3xl pointer-events-none" />
        <div className="relative z-10 max-w-2xl mx-auto px-6">
          <h1 className="font-display text-4xl md:text-5xl font-bold italic text-glow mb-3">
            <span className="text-gold">AGB</span>
          </h1>
          <p className="text-text-muted">Allgemeine Geschäftsbedingungen des JL-Software Shops</p>
        </div>
      </section>

      <div className="max-w-[800px] mx-auto px-6 py-12 space-y-6">
        <div className="bg-surface rounded-2xl border border-white/[0.06] p-6 hover:border-gold/25 transition-all">
          <h2 className="flex items-center gap-3 text-lg font-bold text-gold mb-4">
            <span className="w-1 h-6 bg-gold rounded-full" />
            1. Geltungsbereich
          </h2>
          <p className="text-text-secondary text-sm leading-relaxed">
            Diese Allgemeinen Geschäftsbedingungen gelten für alle Bestellungen über den Online-Shop von JL-Software (Joachim Leiskau). Mit der Bestellung akzeptierst du diese AGB. Abweichende Bedingungen werden nicht anerkannt, es sei denn, wir stimmen ihrer Geltung ausdrücklich schriftlich zu.
          </p>
        </div>

        <div className="bg-surface rounded-2xl border border-white/[0.06] p-6 hover:border-gold/25 transition-all">
          <h2 className="flex items-center gap-3 text-lg font-bold text-gold mb-4">
            <span className="w-1 h-6 bg-gold rounded-full" />
            2. Vertragspartner
          </h2>
          <p className="text-text-secondary text-sm leading-relaxed">
            Der Kaufvertrag kommt zustande mit:<br />
            <strong className="text-text-primary">Joachim Leiskau</strong><br />
            Alkesis-Kivi-Str. 2, 18016 Rostock, Deutschland<br />
            E-Mail: <a href="mailto:JL-Software@gmx.de" className="text-gold hover:underline">JL-Software@gmx.de</a>
          </p>
        </div>

        <div className="bg-surface rounded-2xl border border-white/[0.06] p-6 hover:border-gold/25 transition-all">
          <h2 className="flex items-center gap-3 text-lg font-bold text-gold mb-4">
            <span className="w-1 h-6 bg-gold rounded-full" />
            3. Produktangebot und Preise
          </h2>
          <p className="text-text-secondary text-sm leading-relaxed">
            Alle angegebenen Preise sind Endpreise in Euro (€) und enthalten die gesetzliche Mehrwertsteuer (sofern anwendbar). Versandkosten werden vor Abschluss der Bestellung gesondert ausgewiesen. Digitale Produkte werden per E-Mail oder Download-Link bereitgestellt.
          </p>
        </div>

        <div className="bg-surface rounded-2xl border border-white/[0.06] p-6 hover:border-gold/25 transition-all">
          <h2 className="flex items-center gap-3 text-lg font-bold text-gold mb-4">
            <span className="w-1 h-6 bg-gold rounded-full" />
            4. Bestellvorgang und Zahlung
          </h2>
          <p className="text-text-secondary text-sm leading-relaxed">
            Die Bestellung erfolgt durch das Ausfüllen des Checkout-Formulars. Nach Prüfung deiner Bestellung senden wir dir eine Rechnung mit Zahlungsinformationen per E-Mail zu. Die Zahlung erfolgt per Banküberweisung oder PayPal. Der Versand physischer Produkte erfolgt nach Zahlungseingang.
          </p>
        </div>

        <div className="bg-surface rounded-2xl border border-white/[0.06] p-6 hover:border-gold/25 transition-all">
          <h2 className="flex items-center gap-3 text-lg font-bold text-gold mb-4">
            <span className="w-1 h-6 bg-gold rounded-full" />
            5. Widerrufsrecht
          </h2>
          <p className="text-text-secondary text-sm leading-relaxed">
            Für digitale Produkte (Spiele, Soundtracks, Gutscheine) besteht nach erfolgter Lieferung kein Widerrufsrecht, sofern du vorab ausdrücklich zugestimmt hast, dass mit der Ausführung vor Ablauf der Widerrufsfrist begonnen wird. Bei physischen Produkten hast du ein 14-tägiges Widerrufsrecht ab Erhalt der Ware.
          </p>
        </div>

        <div className="bg-surface rounded-2xl border border-white/[0.06] p-6 hover:border-gold/25 transition-all">
          <h2 className="flex items-center gap-3 text-lg font-bold text-gold mb-4">
            <span className="w-1 h-6 bg-gold rounded-full" />
            6. Lieferung und Versand
          </h2>
          <p className="text-text-secondary text-sm leading-relaxed">
            Digitale Produkte werden innerhalb von 24 Stunden nach Zahlungseingang per E-Mail geliefert. Physische Produkte werden nach Zahlungseingang innerhalb von 2–3 Werktagen versandt. Die Lieferzeit innerhalb Deutschlands beträgt in der Regel 3–5 Werktagen. Gratisversand ab 50 € Bestellwert innerhalb Deutschlands.
          </p>
        </div>

        <div className="bg-surface rounded-2xl border border-white/[0.06] p-6 hover:border-gold/25 transition-all">
          <h2 className="flex items-center gap-3 text-lg font-bold text-gold mb-4">
            <span className="w-1 h-6 bg-gold rounded-full" />
            7. Gewährleistung
          </h2>
          <p className="text-text-secondary text-sm leading-relaxed">
            Es gelten die gesetzlichen Gewährleistungsrechte. Bei digitalen Produkten bieten wir 12 Monate technischen Support ab Kaufdatum an. Bei physischen Produkten beträgt die Gewährleistungsfrist 24 Monate ab Erhalt der Ware.
          </p>
        </div>

        <div className="bg-surface rounded-2xl border border-white/[0.06] p-6 hover:border-gold/25 transition-all">
          <h2 className="flex items-center gap-3 text-lg font-bold text-gold mb-4">
            <span className="w-1 h-6 bg-gold rounded-full" />
            8. Schlussbestimmungen
          </h2>
          <p className="text-text-secondary text-sm leading-relaxed">
            Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Gerichtsstand ist Rostock. Stand dieser AGB: April 2026.
          </p>
        </div>

        <Link to="/" className="inline-flex items-center gap-2 mt-4 text-text-muted hover:text-gold transition-colors text-sm font-medium">
          ← Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}
